export const modalWithButtons = {
  backstage: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(225, 225, 225, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  container: {
    width: '700px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'center',
    backgroundColor: 'white',
    boxShadow: '0 11px 32px 2px rgba(0,0,0,0.1)',
    zIndex: 10,
    '& > h1': {
      fontFamily: 'Roboto',
      fontSize: '1.75rem',
      fontWeight: 400,
      marginTop: '3rem',
      textAlign: 'center',
      width: '100%',
      padding: '0 10%',
      lineHeight: '2.5rem',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2rem 0',
    width: '100%',
  },
  button: {
    padding: '0.75rem 3rem',
    fontSize: '1rem',
    margin: '0 2rem',
  },
};
